<template>
    <div>
        <false-dashboard>

            <!-- dashboard content area -->
            <div class="mt-5 ml-lg-5 pl-lg-4">
                <div class="d-flex align-items-center" v-if="pool != null">
                    <div class="col-lg-8 col-md-12 p-0">

                        <!-- <h5 class="font-weight-bold pb-4 text-center">Pool Invite</h5> -->
                        <div class="card shadow-sm border-0">
                            <div class="card-body p-0 m-0" style="border-top: 2px solid #540D6E;">
                                <!-- <img src="@/assets/placeholder.png" alt="" style="width: 100%; height: 200px;"> -->
                                <div class="body-card px-md-4 px-3 py-4">
                                    <div class="pool-details mb-3">
                                        <small class="text-muted ft-16 mb-3" style="">Title</small>
                                        <h5 class="font-weight-bold ">{{ pool.name }} </h5>
                                        <!-- <small class="text-muted">Organized by <span v-if="pool_convener != null">{{ poolConvenerName }}</span> </small> -->
                                    </div> <hr>

                                    <div class="about">
                                        <h6 class="small text-muted">About</h6>
                                        <p class="">{{ pool.description}}</p>

                                        <div class="d-flex">
                                            <span></span>
                                            <small class="ml-auto text-muted">
                                                {{ pool.created_at | dayDateFormat }}
                                            </small>
                                        </div>
                                    </div> <hr>

                                    <div class="mb-3">


                                        <div class="row mb-3 py-2">
                                            <div class="col-md-6 mb-3 mb-5">
                                                <div class="d-flex">
                                                    <span class="fa fa-user-plus fa-sm mr-3"></span>
                                                    <div class="d-flex flex-column">
                                                        <p class="h6 mb-1">
                                                            {{ pool.member_count - 1 }} other contributors
                                                        </p>
                                                        <small class="text-muted">{{ pool.amount_payable | moneyformat }} each</small>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 mb-5">
                                                <div class="d-flex">
                                                    <span class="fa fa-clock fa-sm mr-3"></span>
                                                    <div class="d-flex flex-column">
                                                        <p class="h6 mb-1">
                                                            {{ pool.contribution_deadline | diffFromNow }} to go
                                                        </p>
                                                        <small class="text-muted">Time until the contribution closes.</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 mb-4">
                                                <div class="d-flex">
                                                    <span class="fa fa-hourglass fa-sm mr-4"></span>
                                                    <div class="d-flex flex-column">
                                                        <p class="h6 mb-1 mt-0">
                                                           5 day holding period
                                                        </p>
                                                        <small class="text-muted">
                                                            The contributions would be held in escrow for a minimum of 5 days before payout can be initiated.
                                                        </small>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col-md-6">
                                                <div v-if="pool.payout_rule == 'majority-vote'">
                                                    <div class="d-flex">
                                                        <span class="fa fa-poll fa-sm mr-4"></span>
                                                        <div class="d-flex flex-column">
                                                            <p class="h6 mb-1 mt-0">
                                                                Contributors vote to decide payout recipients
                                                            </p>
                                                            <small class="text-muted">
                                                                A majority vote would be required to decide who receives the payout from the moneypool.
                                                            </small>
                                                        </div>
                                                    </div> 
                                                </div>
                                                <div v-if="pool.payout_rule == 'organizer-autonomy'">
                                                    <div class="d-flex">
                                                        <span class="fa fa-poll fa-sm mr-4"></span>
                                                        <div class="d-flex flex-column">
                                                            <p class="h6 mb-1 mt-0">
                                                                The organizer decides on the payout recipient(s)
                                                            </p>
                                                            <small class="text-muted">
                                                                The organizer decides on who would receive the contributed amount at the end of the pool.
                                                            </small>

                                                        </div>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="mb-3">
                                            <p class="mb-2 h6">You are to contribute the sum of: 
                                                <span class="h5 font-weight-bold text-success">&#8358;{{ pool.amount_payable | moneyformat}}</span>
                                            </p> 

                                            <div class="d-flex mt-3">
                                                <div class="d-none d-md-block ml-auto">
                                                    <router-link
                                                        :to="{ name: 'confirm-email', params: { pool_id: pool.pool_id} }"
                                                        class="btn btn-custom ml-auto"
                                                        tag="button">
                                                        Proceed
                                                    </router-link>
                                                </div>
                                            </div>
                                            <div class="mt-3">
                                                <div class="d-md-none d-sm-block">
                                                    <router-link
                                                        :to="{ name: 'confirm-email', params: { pool_id: pool.pool_id} }"
                                                        class="btn btn-custom btn-block ml-auto"
                                                        tag="button">
                                                        Proceed
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>

        </false-dashboard>
    </div>
  
</template>

<script>
import FalseDashboard from '@/components/FalseDashboard'

export default {
    data() {
        return {
            pool_id: this.$route.params.pool_id,
        }
    },
    components: {
        FalseDashboard
    },
    computed: {
        pool() {
            return this.$store.getters.pool
        }
    },
    created() {
        this.$store.dispatch('getPool', this.pool_id);
    }
}
</script>

<style>

</style>